// @flow

import { threeDSecure as threeDSecureClient } from '@ebanx/ebanx-js';
import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type IncomingPayment, getReceipts, getCustomerEmail, getSafeCustomerName } from '@tectonics/prs/incoming-payment';
import { getAmountLocal } from '@tectonics/prs/receipts';
import { getAmountValue, getAmountCurrencyCode } from '@tectonics/prs/money/amount';
import { getExpiryMonthFromCardExpiration, getExpiryYearFromCardExpiration } from './format-utils';
import { type ThreeDSecureResponse } from './types';

export async function threeDSecure(userInputValues: UserInputValues, incomingPayment: IncomingPayment): Promise<?ThreeDSecureResponse> {
  const threeDSecureOptions = {
    orderInformation: {
      amountDetails: {
        totalAmount: getAmountValue(getAmountLocal(getReceipts(incomingPayment))),
        currency: getAmountCurrencyCode(getAmountLocal(getReceipts(incomingPayment))),
      },
      billTo: {
        address1: userInputValues['brazilianAddress'],
        administrativeArea: userInputValues['brazilianState'],
        country: 'BR',
        email: getCustomerEmail(incomingPayment),
        homePhone: userInputValues['brazilianPhoneNumber'],
        locality: userInputValues['brazilianCity'],
        postalCode: userInputValues['brazilianZipcode'],
        mobilePhone: userInputValues['brazilianPhoneNumber'],
      },
    },
    paymentInformation: {
      card: {
        number: userInputValues['cardNumber'],
        expirationMonth: getExpiryMonthFromCardExpiration(userInputValues['cardExpiryDate']),
        expirationYear: getExpiryYearFromCardExpiration(userInputValues['cardExpiryDate']),
        holderName: getSafeCustomerName(incomingPayment),
      },
    },
    personalIdentification: {
      id: userInputValues['brazilianDocument'],
      type: userInputValues['brazilianDocumentType'].toUpperCase(),
    },
  };

  return threeDSecureClient.authenticate(threeDSecureOptions);
}
